module.exports = __webpack_public_path__ + "static/media/Sentiment_Logo.75917f3f.png";